import type { SettingsRow } from '@/api/types'

/** Channel 17 groups every booking engine; their policies live in their own table, keyed by booking engine name. */
export const BOOKING_ENGINE_CHANNEL_ID = 17

/** Finds one row of a policy table: the row whose `field` equals `value`. */
export interface PolicyLocator {
  tableKey: string
  field: string
  value: unknown
}

/** Where the policy of a POS lives: booking engines are found by name, every other channel by id. */
export function policyLocatorFor(channelId: number, name: string): PolicyLocator {
  return channelId === BOOKING_ENGINE_CHANNEL_ID
    ? { tableKey: 'booking-engine-policies', field: 'bookingEngine', value: name }
    : { tableKey: 'channel-policies', field: 'channelId', value: channelId }
}

export function policyKindLabel(channelId: number): 'booking engine' | 'channel' {
  return channelId === BOOKING_ENGINE_CHANNEL_ID ? 'booking engine' : 'channel'
}

const normalise = (text: string) => text.toLowerCase().replace(/[^a-z0-9]/g, '')

/** Names are compared loosely (a script folder says "D-edge" where the policy says "D-EDGE"); ids strictly. */
export function matchesLocator(row: SettingsRow, locator: PolicyLocator): boolean {
  const actual = row[locator.field]
  if (typeof actual === 'string' && typeof locator.value === 'string') return normalise(actual) === normalise(locator.value)
  return actual === locator.value
}
